// sagas.js
import { takeLatest, put } from 'redux-saga/effects';
import { policySuccess, policyError } from './action';
import { UPDATE_POLICY_PAYLOAD } from '../actionTypes';

function* getPolicySaga(action) {
  try {
    const { policy } = action.payload;
    if (policy) {
      yield put(policySuccess(policy));
    }
  } catch (error) {
    yield put(policyError(error));
  }
}


export function* watchPolicyData() {
  yield takeLatest(UPDATE_POLICY_PAYLOAD, getPolicySaga);
}

